import { Injectable, computed, inject, signal } from '@angular/core';
import { RestService, RetentionFeatureFlags } from '../rest/rest.service';

const DEFAULT_FLAGS: RetentionFeatureFlags = {
  studyTogetherEnabled: true,
  friendRequestsEnabled: true,
  testSharingEnabled: true,
  leaderboardEnabled: true,
  leaderboardOptInDefault: false,
};

@Injectable({ providedIn: 'root' })
export class RetentionFeatureFlagsService {
  private readonly rest = inject(RestService);
  private readonly loaded = signal(false);
  private readonly flags = signal<RetentionFeatureFlags>({ ...DEFAULT_FLAGS });

  readonly studyTogetherEnabled = computed(() => this.flags().studyTogetherEnabled);
  readonly friendRequestsEnabled = computed(() => this.flags().friendRequestsEnabled);
  readonly testSharingEnabled = computed(() => this.flags().testSharingEnabled);
  readonly leaderboardEnabled = computed(() => this.flags().leaderboardEnabled);
  readonly leaderboardOptInDefault = computed(() => this.flags().leaderboardOptInDefault);

  async ensureLoaded(sessionId: string): Promise<void> {
    if (this.loaded()) {
      return;
    }
    const response = await this.rest.getRetentionFeatureFlags(sessionId);
    if (response) {
      this.flags.set(response);
    }
    this.loaded.set(true);
  }

  reset(): void {
    this.loaded.set(false);
    this.flags.set({ ...DEFAULT_FLAGS });
  }
}
